// extracted by mini-css-extract-plugin
export default {"Introduction":"Introduction--tTccC","main":"main--TFG93","content":"content--LIFOY","pack-up":"pack-up--pUVR3","icon":"icon--A8Bjt"};